import AMLInsightBlock from './AMLInsightBlock';

export default AMLInsightBlock;
